import React from 'react'

export const ModalCreateTaskByHrResponseAsync = React.lazy(() => import('./modal-create-task-searchByHrResponse'))
